  document.getElementById('copy-button').addEventListener('click', function () {
    // Get the text to copy
    const textToCopy = document.getElementById('text-to-copy').innerText;

    // Create a temporary textarea element
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = textToCopy;

    // Add it to the DOM
    document.body.appendChild(tempTextArea);

    // Select the text
    tempTextArea.select();
    tempTextArea.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text
    document.execCommand('copy');

    // Remove the temporary element
    document.body.removeChild(tempTextArea);

    // Optional: Provide feedback to the user
    alert('Copied to clipboard!');
  });
